import React, { useEffect, useRef, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';

import { makeStyles } from '@material-ui/core/styles';

import MemberCard from '../landing-page/MemberCard';

const MEMBERS_PER_PAGE = 9;
const useStyles = makeStyles((theme) => ({
	container: {
		marginTop: 20,
	},
	pagination: {
		marginTop: 30,
		margin: 'auto',
 		width: '50%'
	},
	memberCount: {
		color: "#333333",
		fontFamily: "Graphik",
		fontSize: 18,
		fontWeight: 600,
		letterSpacing: 0,
		float: "left"
	}
}));

function getPageOfMembers(memberList, page) {
	if (memberList !== undefined) {
		const startIndex = (page - 1) * MEMBERS_PER_PAGE;
		return memberList.slice(startIndex, startIndex + MEMBERS_PER_PAGE);
	} else {
		return []
	}
}

function getMaxPageCount(memberList) {
	if (memberList !== undefined) {
		return Math.ceil(memberList.length / MEMBERS_PER_PAGE);
	} else {
		return 0;
	}
}

const MemberGrid = (props) => {
	const {memberList} = props;
	const [page, setPage] = useState(props.page);
	const numberOfMembers = (memberList !== undefined) ? memberList.length : 0;

	useEffect(() => {
		setPage(1);
		}, [memberList]); 

	const classes = useStyles();

	return (
		<div>
        	<span className={classes.memberCount}>{numberOfMembers} Members Of Congress</span>
			<Grid className={classes.container} container spacing={3}>
				{getPageOfMembers(memberList, page).map((member) => (
					<Grid item key={member.personId} xs={12} sm={6} lg={4}>
						<MemberCard {...member} />
					</Grid>
				))}			
			</Grid>
			<Pagination
				className={classes.pagination}
				count={getMaxPageCount(memberList)}
				variant="outlined"
				shape="rounded"
				page={page}
				onChange={(event,val)=> setPage(val)}
			/>
		</div>
	);
}

export default MemberGrid;
